import { render, staticRenderFns } from "./PurchasedAccProductListHeader.vue?vue&type=template&id=832a0b4a"
import script from "./PurchasedAccProductListHeader.vue?vue&type=script&lang=js"
export * from "./PurchasedAccProductListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports